import { createSelector } from '@reduxjs/toolkit';
import { BuzzerState, Command, GuardZoneState, PumpState, RelayControlState, } from 'z3k-config';
import { select_object_array_parts } from '../components/utils/utils';
import { select_boiler_modes, select_consumer_modes } from 'z3k-parser/lib/z3k-selectors';
import { findAndChangeLinks } from 'z3k-parser/lib/find-links';
import { deepDiff } from 'utils';
import { object2id } from 'z3k-parser/lib';
const commandsOptionsSelector = createSelector(select_object_array_parts('guard_zones', ['id', 'name']), select_object_array_parts('buzzers', ['id', 'name']), select_object_array_parts('pumps', ['id', 'name']), select_object_array_parts('relay_controls', [
    'id',
    'name',
]), select_object_array_parts('threeway_taps', [
    'id',
    'name',
]), select_object_array_parts('group_boiler_heating_modes', ['id', 'name']), select_object_array_parts('group_heating_modes', [
    'id',
    'name',
]), (guard_zones, buzzers, pumps, relay_controls, threeway_taps, group_heating_modes, group_boiler_heating_modes) => [
    {
        options: guard_zones,
        text: 'Поставить охранную зону «name» на охрану',
        cmd: GuardZoneState.GUARD_ON.toString(),
    },
    {
        options: guard_zones,
        text: 'Снять охранную зону «name» с охраны',
        cmd: GuardZoneState.GUARD_OFF.toString(),
    },
    {
        options: guard_zones,
        text: "Инвертировать состояние охранной зоны 'name'",
        cmd: GuardZoneState.ALARM.toString(),
    },
    {
        options: buzzers,
        text: 'Включить сирену «name»',
        cmd: BuzzerState.ON.toString(),
    },
    {
        options: buzzers,
        text: 'Выключить сирену «name»',
        cmd: BuzzerState.OFF.toString(),
    },
    {
        options: pumps,
        text: 'Включить насос «name»',
        cmd: PumpState.ON.toString(),
    },
    {
        options: pumps,
        text: 'Выключить насос «name»',
        cmd: PumpState.OFF.toString(),
    },
    {
        options: relay_controls,
        text: 'Включить реле «name»',
        cmd: RelayControlState.ON.toString(),
    },
    {
        options: relay_controls,
        text: 'Выключить реле «name»',
        cmd: RelayControlState.OFF.toString(),
    },
    {
        options: threeway_taps,
        text: 'Открыть кран «name»',
        cmd: '1',
    },
    {
        options: threeway_taps,
        text: 'Закрыть кран «name»',
        cmd: '2',
    },
    {
        options: group_heating_modes,
        text: 'Включить режим «name»',
        cmd: '1',
        group: 'heating_modes',
    },
    {
        options: group_boiler_heating_modes,
        text: 'Включить режим «name»',
        cmd: '1',
        group: 'boiler_heating_modes',
    },
]);
export const addAllPossibleCommands = (config) => {
    const group_heating_modes = select_consumer_modes(config);
    const group_boiler_heating_modes = select_boiler_modes(config);
    const data = {
        ...config,
        group_heating_modes,
        group_boiler_heating_modes,
    };
    const commandsOptions = commandsOptionsSelector(data);
    const clean_config = Command.get
        .where(config, (cmd) => cmd.objectid == null)
        .map(object2id)
        .reduce((temp_conf, id_for_delete) => findAndChangeLinks(Command.get.removeById(temp_conf, id_for_delete), id_for_delete), config);
    const new_config = commandsOptions.reduce((config, { options, text, cmd, group }) => {
        return options.reduce((group_config, { name, id }) => {
            const command_name = text.replace('name', name);
            const updated_config = Command.get.modify(group_config, ({ objectid, cmd: command_cmd }) => objectid == id && command_cmd === cmd, (cmd) => ({
                ...cmd,
                name: command_name,
            }));
            const diff = deepDiff(updated_config, group_config);
            // проверяем были ли изменения
            if (Object.keys(diff).length > 0) {
                return updated_config;
            }
            // смотрим, может такая команда уже есть?
            if (Command.get.some(updated_config, ({ objectid, cmd: command_cmd }) => objectid == id && command_cmd === cmd)) {
                return updated_config;
            }
            [, group_config] = Command.get.add(group_config, {
                name: command_name,
                objectid: id,
                cmd,
                group,
            });
            return group_config;
        }, config);
    }, clean_config);
    return new_config;
};
